import React from 'react';
import Hero from '../components/Sections/Hero';
import ServicePreview from '../components/Sections/ServicePreview';
import Testimonials from '../components/Sections/Testimonials';
import CallToAction from '../components/Sections/CallToAction';
import ChatBot from '../components/ChatBot';
import styles from './Home.module.css';

const Home = () => {
    return (
        <div className={styles.home}>
            <Hero />
            <ServicePreview />
            <Testimonials />
            <CallToAction />
            <ChatBot />
        </div>
    );
};

export default Home;